/**
 * Vue iziToast plugin.
 */

// import toast.
import iziToast from 'izitoast'

// import lodash's assign.
import { assign, isEmpty, map } from 'lodash'

/**
 * Plugin export.
 */
export default function (vue, router) {
  return {
    /**
    * Default iziToast options.
    */
    options: {
      // default position.
      position: 'topCenter',
      // default layout.
      layout: 1
    },

    optionsDialog: {
      timeout: 4000,
      theme: 'light',
      icon: 'icon-drafts',
      class: 'custom1',
      balloon: true,
      position: 'bottomCenter', // bottomRight, bottomLeft, topRight, topLeft, topCenter, bottomCenter
      progressBarColor: 'rgb(0, 255, 184)',
      onOpening (instance, toast) {
      },
      onClosing (instance, toast, closedBy) {
      }
    },

    /**
    * The stay method creates a config object for a persistent toast.
    *
    * @returns {*}
    */
    stay () {
      return assign({timeout: null, progressBar: false}, this.options)
    },

    /**
    * The leave method creates a config object for a toast the disappears after some time.
    *
    * @returns {*}
    */
    leave (timeout = 5000) {
      return assign({ timeout, progressBar: true }, this.options)
    },

    /**
    * The method that actually fires the toast.
    *
    * @param {String}  type
    * @param {String}  message
    * @param {Object}  config
    * @param {Boolean} stay
    */
    toast (type, message, config, stay) {
      // base options based on stay|hide config.
      const baseOptions = stay ? this.stay() : this.leave()
      // inject the message into the basic configuration.
      const messagedOptions = assign(baseOptions, { message })
      // merge the custom configuration passed by client.
      const finalOptions = assign(messagedOptions, config)

      // launches the toast.
      iziToast[type](finalOptions)
    },

    /**
    * Launches a "info" (blue) styled toast.
    * @param message
    * @param stay
    * @param config
    */
    info (message, stay = false, config = {}) {
      this.toast('info', message, config, stay)
    },

    /**
    * Launches a "success" (green) styled toast.
    * @param message
    * @param stay
    * @param config
    */
    success (message, stay = false, config = {}) {
      this.toast('success', message, config, stay)
    },

    /**
    * Launches a "warning" (yellow) styled toast.
    * @param message
    * @param stay
    * @param config
    */
    warning (message, stay = false, config = {}) {
      this.toast('warning', message, config, stay)
    },

    /**
    * Launches a "error" (routerred) styled toast.
    * @param message
    * @param stay
    * @param config
    */
    error (message, stay = false, config = {}) {
      this.toast('error', message, config, stay)
    },
    dialog (buttons, message = '', title = 'Próximos passsos: &nbsp;&nbsp;', image = '/static/images/icons/north-east.png', config = {}) {
      const newButtons = map(buttons, (button) => {
        return [
          `<button>${button.title}</button>`, function (instance, toast) {
            const doClose = () => {
              instance.hide({
                transitionOut: 'fadeOutUp',
                onClosing (instance, toast, closedBy) {
                }
              }, toast, 'buttonName')
            }
            if (!isEmpty(button.callback) && (typeof button.callback === 'function')) {
              if (isEmpty(button.auto_close) || button.auto_close) {
                doClose()
              }
              return button.callback(instance, toast)
            }
            const route = (typeof button.route === 'object') ? button.route : { name: button.route }
            router.push(route)
            doClose()
          }, true
        ]
      })
      iziToast.show({
        ...this.options,
        ...this.optionsDialog,
        ...config,
        title,
        message,
        image,
        buttons: newButtons
      })
    },

    /**
    * Destroy all toasts actively being displayed.
    */
    destroyAll () {
      iziToast.destroy()
    }
  }
}



// WEBPACK FOOTER //
// ./src/plugins/toast/toast.js